const MAX_SIDE = 2000;
const MAX_UPLOAD = 8 * 1024 * 1024;
const IMAGE_EXT = /\.(jpe?g|png|webp|heic|heif|gif|bmp)$/i;

export function isImageFile(f) {
  return (f.type && f.type.startsWith('image/')) || IMAGE_EXT.test(f.name || '');
}

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('decode')); };
    img.src = url;
  });
}

// Resizes phone photos to max 2000px JPEG so uploads stay small and fast.
export async function prepareImage(file) {
  try {
    const img = await loadImage(file);
    const scale = Math.min(1, MAX_SIDE / Math.max(img.naturalWidth, img.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.naturalWidth * scale);
    canvas.height = Math.round(img.naturalHeight * scale);
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise((r) => canvas.toBlob(r, 'image/jpeg', 0.85));
    if (!blob) throw new Error('encode');
    const name = (file.name || 'bild').replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], name, { type: 'image/jpeg' });
  } catch {
    if (file.size > MAX_UPLOAD) throw new Error(`Bild konnte nicht verarbeitet werden: ${file.name}`);
    return file;
  }
}
